import React from 'react'
import { Paper } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { useDispatch, useSelector } from 'react-redux'
import { withRouter } from 'react-router-dom'
import {
    /*eliminarFC_36AnexoUnidadAlmacen,
    eliminarFC_36AnexoUnidadEnvasado,
    eliminarFC_36AnexoUnidadProduccion,*/
    obtenerFC_36UnidadAlmacenMap,
    obtenerFC_36UnidadEnvasadoMap,
    obtenerFC_36UnidadProduccionMap,
    eliminarFC_36AnexoInstalacion, limpiarMapInstalaciones
} from '../../../redux/DucksBeneficiario/FC_36Ducks'

import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { Typography } from '@mui/material';
import estilos from './FormularioFC36BeneficiarioComponent.module.css'
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

function TablaAnexosFC36(props) {

    const dispatch = useDispatch()
    const { api = undefined } = props
    const { handdleInstalacionesBaja, handdleInstalacionesAlta } = api
    const modoEdicionBorrador = useSelector(store => store.FC_36Solicitud.modoEdicionBorrador)
    const modoCorreccion = useSelector(store => store.FC_36Solicitud.modoCorreccion)
    const validacionInstalacion = useSelector(store => store.FC_36Solicitud.validacionInstalacion)
    const actividadesEmpresa = useSelector(store => store.FC_36Solicitud.actividadesEmpresa)
    let fc_36 = useSelector(store => store.FC_36Solicitud.fc_36)
    /*Modal*/
    const [openModal, setOpenModal] = React.useState(false);
    const [titleModal, setTitleModal] = React.useState('');
    const [bodyModal, setBodyModal] = React.useState('')
    const [accion, setAccion] = React.useState('')
    const [parametros, setParametros] = React.useState()
    const handleOpenModal = (data) => {
        setTitleModal(data.title)
        setBodyModal(data.body)
        setAccion(data.accion)
        setParametros(data.parametros)
        setOpenModal(true)
    }
    const handleCloseModal = () => {
        setTitleModal('')
        setBodyModal('')
        setAccion('')
        setParametros()
        setOpenModal(false)
    }

    const modalComponent = () => {
        return (
            <div>
                <Modal
                    open={openModal}
                    onClose={handleCloseModal}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            <center>{titleModal}</center>
                        </Typography>
                        <Typography id="modal-modal-description" sx={{ mt: 2, textAlign: 'center' }} component="h2">
                            {bodyModal} <br /> <center><strong>¿Desea continuar?</strong></center>
                        </Typography>
                        <br />
                        <div className='row'>
                            <button className='btn btn-success' onClick={() => {
                                switch (accion) {
                                    case 'eliminarAnexo':
                                        eliminarAnexo(parametros)
                                        break;
                                    default:
                                        break;
                                }
                            }
                            }>CONTINUAR</button>
                        </div>
                    </Box>
                </Modal>
            </div>
        )
    }

    const eliminarAnexoModal = (params) => {
        handleOpenModal({
            title: `¡Advtertencia!`,
            body: `Está a punto de eliminar un anexo, esta acción no se podrá revertir.`,
            accion: 'eliminarAnexo',
            parametros: params
        })
    }

    const eliminarAnexo = (params) => {
        if (modoEdicionBorrador) {
            props.handdleDeleteOptionFile(params.row.id)
            dispatch(eliminarFC_01AnexoInstalacionBD({
                idfc01_solicitudregistro: params.row.idfc01_solicitudregistro,
                idanexo: params.row.idanexo,
                id: params.row.id
            }))
        } else {
            props.handdleDeleteOptionFile(params.id)
            dispatch(eliminarFC_36AnexoInstalacion(params.id))
        }
        handleCloseModal()
    }

    const editarAnexo = async (params) => {
        switch (params.row.tipoInstalacion) {
            case 'Unidad Almacén':
                await dispatch(limpiarMapInstalaciones())
                props.history.push('/fc_36AnexoAlmacen', { idEdit: params.id, relacioncontacto: params.row.relacioncontacto })
                break;
            case 'Unidad Envasado':
                await dispatch(limpiarMapInstalaciones())
                props.history.push('/fc_36AnexoEnvasado', { idEdit: params.id, relacioncontacto: params.row.relacioncontacto })
                break;
            case 'Unidad Producción':
                await dispatch(limpiarMapInstalaciones())
                props.history.push('/fc_36AnexoProduccion', { idEdit: params.id, relacioncontacto: params.row.relacioncontacto })
                break;
            default:
                break;
        }
    }
    async function corregirAnexo(params) {
        switch (params.row.anexo) {
            case 'Unidad Almacén':
                await dispatch(obtenerFC_36UnidadAlmacenMap(params.row.idfc_36informaciongeneral))
                props.history.push('/fc_36AnexoAlmacen', { idEdit: params.id })
                break;
            case 'Unidad Envasado':
                await dispatch(obtenerFC_36UnidadEnvasadoMap(params.row.idfc_36informaciongeneral))
                props.history.push('/fc_36AnexoEnvasado', { idEdit: params.id })
                break;
            case 'Unidad Producción':
                await dispatch(obtenerFC_36UnidadProduccionMap(params.row.idfc_36informaciongeneral))
                props.history.push('/fc_36AnexoProduccion', { idEdit: params.id })
                break;
            default:
                break;
        }
    }

    const columns = [
        { field: 'anexo', headerAlign: 'center', headerName: 'Tipo de instalación', flex: 1, headerClassName: estilos.headerSolicitudes, },
        { field: 'alias', headerAlign: 'center', headerName: 'Alias', flex: 1, headerClassName: estilos.headerSolicitudes, },
        { field: 'domicilio', headerAlign: 'center', headerName: 'Domicilio', flex: 1, headerClassName: estilos.headerSolicitudes, },
        {
            field: 'accion', headerAlign: 'center', headerName: 'Acción', flex: .5, headerClassName: estilos.headerSolicitudes,
            renderCell: (params) => (

                ((params.row.baja === false || params.row.baja === true) && params.row.isbaja === false) ?
                    <button className={params.row.baja === false ? `btn btn-outline-warning ms-1` : params.row.baja === true ? `btn btn-danger ms-1` : ''}
                        onClick={() => { botonBaja(params) }} /*disabled={fc_36.actualizacioncadena}*/ >Baja</button>
                    : params.row.isbaja == true ?
                        <button className={(params.row.baja === false && params.row.alta === false) ? `btn btn-outline-warning ms-1` : (params.row.baja === false && params.row.alta === true) ? `btn btn-success ms-1` : ''}
                            onClick={() => { botonAlta(params.row) }} >Dar de Alta</button>
                        : (!modoCorreccion && (params.row.relacioncontacto === null || params.row.relacioncontacto === undefined)) &&
                        <button onClick={() => { eliminarAnexoModal(params) }} className='btn btn-danger btn-sm'>Eliminar</button>
            )
        },
        {
            field: 'accionEditar', headerAlign: 'center', headerName: 'Editar', flex: .5, headerClassName: estilos.headerSolicitudes,
            renderCell: (params) =>
            (
                modoCorreccion && (params.row.relacioncontacto == null || params.row.relacioncontacto == undefined) ?
                    <button onClick={() => corregirAnexo(params)} className='btn btn-danger btn-sm' >Corregir</button>
                    : (params.row.relacioncontacto == null || params.row.relacioncontacto == undefined) &&
                    (<button onClick={() => editarAnexo(params)} className='btn btn-warning btn-sm'>Editar</button>)
            )
        }
    ]

    const rows = [];
    const data = props.rows
    if (data.length > 0) {
        data.map(item => {
            if (item.data) {
                let anexoRow = Object.assign({}, item.data)
                anexoRow.anexo = anexoRow.tipoInstalacion
                if ((actividadesEmpresa.productormezcal == true || actividadesEmpresa.productormezcalaltabaja) && anexoRow.anexo == 'Unidad Producción') rows.push(anexoRow)
                if ((actividadesEmpresa.envasador == true || actividadesEmpresa.envasadoraltabaja) && anexoRow.anexo == 'Unidad Envasado') rows.push(anexoRow)
                if ((actividadesEmpresa.comercializadormezcal == true || actividadesEmpresa.comercializadorbebidasconmezcal == true ||
                    actividadesEmpresa.comercializadormezcalaltabaja || actividadesEmpresa.comercializadorbebidasaltabaja ||
                    actividadesEmpresa.envasador == true || actividadesEmpresa.envasadoraltabaja) 
                    && anexoRow.anexo == 'Unidad Almacén') rows.push(anexoRow)
            } else {
                let anexoRow = Object.assign({}, item)
                anexoRow.anexo = anexoRow.tipoInstalacion
                if ((actividadesEmpresa.productormezcal == true || actividadesEmpresa.productormezcalaltabaja) && anexoRow.anexo == 'Unidad Producción') rows.push(anexoRow)
                if ((actividadesEmpresa.envasador == true || actividadesEmpresa.envasadoraltabaja) && anexoRow.anexo == 'Unidad Envasado') rows.push(anexoRow)
                if ((actividadesEmpresa.comercializadormezcal == true || actividadesEmpresa.comercializadorbebidasconmezcal == true ||
                    actividadesEmpresa.comercializadormezcalaltabaja || actividadesEmpresa.comercializadorbebidasaltabaja ||
                    actividadesEmpresa.envasador == true || actividadesEmpresa.envasadoraltabaja ||
                    actividadesEmpresa.productormezcal == true || actividadesEmpresa.productormezcalaltabaja)
                    && anexoRow.anexo == 'Unidad Almacén') rows.push(anexoRow)
            }
        })
    }
    const botonBaja = async (params) => {
        handdleInstalacionesBaja(params)
    }
    const botonAlta = async (params) => {
        handdleInstalacionesAlta(params)
    }
    return (
        <div className='row ms-1 mt-5'>
            <div className='row  mb-2'>
                <div className='row justify-content-md-center divBorderNaranja'>
                    <h6 className='text-center'>Tabla de anexos {props.nombreAnexo}</h6>
                </div>
                <div className='col-12' style={{ color: 'black' }}>
                    <div style={{ height: (130 + (data.length * 50)), width: '104%', color: 'black' }}>
                        <DataGrid
                            rows={rows}
                            columns={columns}
                            // pageSize={10}

                            rowsPerPageOptions='none'
                            sx={{
                                boxShadow: 0,
                                border: 0,
                                color: 'black',
                                backgroundColor: 'white !important'
                            }}
                        />
                    </div>
                </div>
            </div>
            {modalComponent()}
        </div>
    )
}

export default withRouter(TablaAnexosFC36)
